export default __webpack_public_path__ + "static/media/userTick.aba4f911.svg";